declare global {
	interface Window {
		gtag: (option: string, gaTrackingId: string, options: Record<string, unknown>) => void;
	}
}

export const gaPageView = (url: string, trackingId: string) => {
	if (!window.gtag) {
		console.warn('window.gtag is not defined. This could mean your google analytics script has not loaded on the page yet.');
		return;
	}
	window.gtag('config', trackingId, {
		page_path: url,
	});
};

export const gaEvent = ({ action, category, label, value }: Record<string, string>) => {
	if (!window.gtag) {
		console.warn('window.gtag is not defined. This could mean your google analytics script has not loaded on the page yet.');
		return;
	}
	window.gtag('event', action, {
		event_category: category,
		event_label: label,
		value: value,
	});
};

export const gaCustomEvent = ({
	action,
	params,
	items,
	callback,
}: {
	action: string;
	params: Record<string, string | any>;
	items?: any;
	callback?: () => void;
}) => {
	try {
		if (!window.gtag) {
			console.warn('window.gtag is not defined. This could mean your google analytics script has not loaded on the page yet.');
			return;
		}

		if (items) {
			const itemsToSend = prepareItems({ items });
			params.items = itemsToSend;
		}

		window.gtag('event', action, {
			...params,
			event_callback: () => {
				if (callback) callback();
			},
		});
	} catch (error) {
		console.error('Error sending GA event', error);
	}
};

export const prepareItems = ({ items }: { items: [Record<string, string>] }) => {
	return items.map((item: any) => {
		const { id, quantity, total } = item;
		return {
			item_id: id.code,
			item_name: id.name,
			item_brand: id.brand.name,
			price: total ? (total / quantity).toFixed(2) : id.salePrice,
			quantity: quantity,
		};
	});
};
